import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import DeleteIcon from "@mui/icons-material/Delete";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import LabelImportantOutlinedIcon from "@mui/icons-material/LabelImportantOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import TextSnippetOutlinedIcon from "@mui/icons-material/TextSnippetOutlined";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Tooltip,
} from "@mui/material";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { green } from "@mui/material/colors";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataDescriptor } from "../../context/DataDescriptor";
import { DataQC } from '../../context/DataQC';
import { DataUser } from "../../context/DataUser";
import styles from "../../css/QCReview.module.css";
import { exportQCComments } from "../../utils/exports/exportQCComments";
import ModalDelete from "../describer/ModalDelete";

export const QCReview = () => {

  const { currentRegion, recommendCharacterMax, regions } = useContext(DataDescriptor);
  const { currentProject } = useContext(DataUser);
  const navigate = useNavigate();
  const marketDescription = useRef();

  const {
    selectedButton,
    isDescriptionButtonActive,
    isPreviewButtonActive,
    isClientButtonActive,
    isCommentsToClientButtonActive,
    isCommentButtonActive,
    isReasonButtonActive,
    handleButtonClick,
    handleEditingDescription,
    handleDescriptionEditor,
    handleCommentsToClientChange,
    handleSaveCommentsToClient,
    currentDescription, setCurrentDescription,
    commentsToClient,
    commentsToClientDirty,
    savingCommentsToClient,
    isEditingDescription, setIsEditingDescription,
    handleChangeCHBX,
    handleSaveComment,
    allApproved,
    singleApproved, setSingleApproved,
    textarea, setTextarea,
    handleTextAreaComments,
    openToast, setOpenToast,
    message,
    setMessage,
    toastSeverity,
    setToastSeverity,
  } = useContext(DataQC);

  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openReturnModal, setOpenReturnModal] = useState(false);
  const [isReturningToDescriber, setIsReturningToDescriber] = useState(false);
  const showCommentsToClient = currentProject?.client?.[0] === true || currentProject?.client?.[0] === "true";
  const isQC1 = currentProject?.rol?.role === "QC";

  useEffect(() => {
    handleButtonClick("descriptionBtn")
  }, [currentRegion]);

  // todo: ------------------------Read description from DB------------------------
  useEffect(() => {
    const hasVoiceOver = currentProject?.users?.filter((user) => user?.role === 'AN_D');

    (async () => {
      if (currentProject.service === "dubbing") {
        setCurrentDescription(currentRegion.data.caption);
      } else {
        setCurrentDescription(currentRegion.data?.description);
        if (!currentRegion?.data?.description && hasVoiceOver) {
          setCurrentDescription(currentRegion.data.caption);
        }
      }
    })();
  }, [isEditingDescription, currentRegion]);

  // todo: -----------------------QC Review Data from DB-----------------------
  // Read data from DB and color selected region
  useEffect(() => {
    if (currentRegion) {
      setTextarea(currentRegion?.data?.review?.comment ? currentRegion.data.review.comment[0] : '');
      setSingleApproved(Boolean(currentRegion.data?.review?.approved));
      currentRegion.update({ color: "rgba(255, 199, 0, 0.3)" });
      setIsEditingDescription(false); // to avoid the description editor to be open when changing btwn regions
    }
  }, [currentRegion]);

  const handleClickOpenModalDelete = () => {
    setOpenModalDelete(true);
  };

  const handleExportQCComments = () => {
    exportQCComments(regions, currentProject?.name);
  };

  const handleReturnToDescriber = async () => {
    if (!currentProject?._id) return;

    setIsReturningToDescriber(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_URL}/api/projects/return-to-descriptor/${currentProject._id}`,
        { method: "PUT" }
      );

      if (!response.ok) throw new Error("Unable to return the project to the describer.");

      setMessage("Project returned to describer successfully.");
      setToastSeverity("success");
      setOpenReturnModal(false);
      navigate("/dashboard");
    } catch (error) {
      setMessage("Unable to return the project to the describer.");
      setToastSeverity("error");
    } finally {
      setOpenToast(true);
      setIsReturningToDescriber(false);
    }
  };

  return (
    <div className={styles.qc_container}>
      <div id="buttons_container" className={styles.div__btnsContainer}>
        <button
          id='descriptionBtn'
          className={`${styles.btn__description} ${styles.btn__qc} ${selectedButton === 'descriptionBtn' ?
            styles.btn__selected :
            styles.btn__unselected
            } ${currentRegion.data.comment === undefined && currentRegion.data.commentClient === "" && currentRegion.data?.description?.preview === ""
              ? styles.btn__comments_only
              : null
            }`}
          onClick={() => handleButtonClick("descriptionBtn")}
          aria-label='description'
          aria-describedby='current-description'
        >
          <TextSnippetOutlinedIcon />
          <p>Description</p>
          {currentProject.rol?.role !== "QC2" && isEditingDescription ? (
            <HighlightOffIcon onClick={handleEditingDescription} />
          ) : currentProject.rol?.role !== "QC2" ? (
            <EditOutlinedIcon onClick={handleEditingDescription} />
          ) : null}
        </button>

        {currentProject.rol?.role === "QC" ? (
          <button
            id="previewBtn"
            className={`
                        ${styles.btn__preview} 
                        ${styles.btn__qc} 
                        ${selectedButton === "previewBtn"
                ? styles.btn__selected
                : styles.btn__unselected
              }
                        ${currentRegion.data.comment === undefined && currentRegion.data.commentClient === ""
                ? styles.btn__comments
                : null
              }
                    `}

            style={{
              display:
                currentRegion.data?.description?.preview === ""
                  ? "none"
                  : "flex",
            }}
            onClick={() => handleButtonClick("previewBtn")}
          >
            <p>Preview</p>
          </button>
        ) : null}

        {showCommentsToClient ? (
          <button
            id="commentsToClientBtn"
            className={`${styles.btn__preview} ${styles.btn__qc} ${styles.btn__commentsToClient} ${selectedButton === "commentsToClientBtn"
              ? styles.btn__selected
              : styles.btn__unselected
              }`}
            onClick={() => handleButtonClick("commentsToClientBtn")}
            aria-label="Comments to client"
            aria-describedby="comments-to-client-textarea"
          >
            <p>Comments to client</p>
          </button>
        ) : null}

        {currentProject.rol?.role === "QC2" ? (
          <button
            id="reasonBtn"
            className={`${styles.btn__preview} ${styles.btn__qc} ${selectedButton === "reasonBtn"
              ? styles.btn__selected
              : styles.btn__unselected
              }`}
            style={{
              display:
                currentRegion?.data?.description?.reason4change === ""
                  ? "none"
                  : "flex",
            }}
            onClick={() => handleButtonClick("reasonBtn")}
          >
            <p>Reason</p>
          </button>
        ) : null}

        {currentRegion.data.commentClient ? (
          <button
            id="clientBtn"
            className={`${styles.btn__preview} ${styles.btn__qc} ${selectedButton === "clientBtn"
              ? styles.btn__selected
              : styles.btn__unselected
              } ${currentRegion.data.comment === undefined
                ? styles.btn__comments
                : null
              }`}
            style={{
              display:
                currentRegion.data.commentClient === ""
                  ? "none"
                  : "flex",
            }}
            onClick={() => handleButtonClick("clientBtn")}
          >
            <p>Client</p>
          </button>
        ) : null}

        <button
          id='commentsBtn'
          className={`${styles.btn__comments} ${styles.btn__qc} ${selectedButton === 'commentsBtn' ?
            styles.btn__selected :
            styles.btn__unselected
            }`}
          style={{
            display:
              currentRegion.data.comment === undefined
                ? "none"
                : "flex",
          }}
          onClick={() => handleButtonClick("commentsBtn")}
          aria-label="annotation"
          aria-describedby='current-comment'
        >
          <LabelImportantOutlinedIcon />
          <p>Annotation</p>
        </button>

        <div className={styles.deleteAction}>
          {currentProject.rol?.role === "QC" ? (
            <>
              <button
                variant="contained"
                onClick={() => handleClickOpenModalDelete()}
                disabled={currentRegion.data?.review?.approved ? true : false}
                className={styles.button}
              >
                <DeleteIcon fontSize="large" />
              </button>
              <ModalDelete open={openModalDelete} setOpen={setOpenModalDelete} />
            </>
          ) : null}
        </div>

      </div>

      {isDescriptionButtonActive && !isEditingDescription ? (
        <>
          <div ref={marketDescription} id='current-description' aria-label={'current description is,' + currentDescription?.initial} className={styles.qc_content} >
            {currentProject.service === "dubbing" ? (
              <p>{currentDescription}</p>
            ) : (
              <p dangerouslySetInnerHTML={{ __html: currentDescription?.initial || currentDescription }}></p>
            )}
            <div
              className={styles.container__count}
              style={{
                color:
                  (currentDescription?.initial || currentDescription) > Math.round(recommendCharacterMax)
                    ? "red"
                    : "green",
              }}
            >
              <span className={styles.span__characterCount}>
                {Math.round(recommendCharacterMax) - (currentDescription?.initial || currentDescription)?.length}
              </span>
            </div>
          </div>
          <div className={styles.container__textCount}>

            {(currentDescription?.initial?.length ? currentDescription?.initial?.length : 0) > Math.round(recommendCharacterMax) && (
              <h4 style={{ color: "var(--orange)" }}>
                {" "}
                WARNING: You have exceeded the limit{" "}
                {Math.round(recommendCharacterMax)} you have {currentDescription?.initial?.length} characters.
              </h4>
            )}
          </div>
        </>
      ) : null}

      {isPreviewButtonActive ? (
        <p className={styles.qc_content} >
          {/* {currentRegion.data.description.preview ? currentRegion.data.description.preview : ''} */}
          {currentDescription?.preview ? currentDescription.preview : ''}
        </p>
      ) : null}

      {isReasonButtonActive ? (
        <p className={styles.qc_content} >
          {/* {currentRegion.data.description.preview ? currentRegion.data.description.preview : ''} */}
          {currentDescription?.reason4change ? currentDescription?.reason4change : ''}
        </p>
      ) : null}

      {isClientButtonActive ? (
        <p className={styles.qc_content} >
          {currentRegion.data?.commentClient ? currentRegion.data?.commentClient : ''}
        </p>
      ) : null}



      {isCommentButtonActive ? (
        <h4 id="current-comment" aria-label={'current comment is,' + currentRegion?.data?.comment} className={styles.qc_content} >
          {currentRegion.data.comment ? currentRegion.data.comment : ''}
        </h4>
      ) : null}

      {isCommentsToClientButtonActive && showCommentsToClient ? (
        <div>
          <div className={styles.qc__title}>
            <h2 className={styles.qc__title2}>Comments to client</h2>
            {commentsToClientDirty ? (
              <button
                onClick={handleSaveCommentsToClient}
                disabled={savingCommentsToClient}
                aria-label="Save Comments to client"
              >
                <SaveOutlinedIcon />
              </button>
            ) : null}
          </div>
          <textarea
            id="comments-to-client-textarea"
            value={commentsToClient}
            placeholder="Type Comments..."
            onChange={handleCommentsToClientChange}
            className={styles.textArea_description}
          />
          {currentRegion.data?.commentClient ? (
            <div className={styles.commentsToClient__clientComment}>
              <h2 className={styles.qc__title2}>Client comment</h2>
              <p className={styles.qc_content}>{currentRegion.data.commentClient}</p>
            </div>
          ) : null}
        </div>
      ) : null}

      {isEditingDescription ? (
        <div style={{ position: "relative" }}>
          <textarea
            key={currentRegion?.data?.id}
            id='description-editor'
            defaultValue={currentRegion.data?.description?.initial || ""}
            onChange={handleDescriptionEditor}
            className={styles.textArea_editing_description}
          />
          {/* {currentDescription.initial} */}
          <div
            className={styles.container__count}
            style={{
              color:
                currentDescription?.initial?.length > Math.round(recommendCharacterMax)
                  ? "red"
                  : "green",
            }}
          >
            <span className={styles.span__characterCount}>
              {Math.round(recommendCharacterMax) - currentDescription?.initial?.length}
            </span>
          </div>
        </div>
      ) : null}

      {!isCommentsToClientButtonActive ? (
        <>
          <hr className={styles.qc__divider} />

          <div className={styles.qc__title}>
            <h2 className={styles.qc__title2}>QC Corrections</h2>
            <div className={styles.qc__actions}>
              {isQC1 ? (
                <Tooltip title="Return to Describer">
                  <button
                    onClick={() => setOpenReturnModal(true)}
                    aria-label="Return to Describer"
                  >
                    <AssignmentReturnIcon />
                  </button>
                </Tooltip>
              ) : null}
              <button
                onClick={handleExportQCComments}
                aria-label="Download QC comments as Excel"
                title="Download QC comments as Excel"
              >
                <FileDownloadOutlinedIcon />
              </button>
              <button onClick={handleSaveComment} aria-label="Save Quality Control Review">
                <SaveOutlinedIcon />
              </button>
            </div>
          </div>
          <textarea
            id="QCTextarea"
            disabled={singleApproved || (singleApproved && allApproved)}
            value={textarea || ""}
            placeholder="Type Comments..."
            onChange={handleTextAreaComments}
            className={
              singleApproved || (singleApproved && allApproved)
                ? styles.textArea_description_db
                : styles.textArea_description
            }
          />
          <FormControlLabel
            className={styles.lb__approve}
            control={
              <Checkbox
                id="approveCHBX"
                // onChange={handleChangeCHBX}
                onClick={(e) => handleChangeCHBX(e)} // to avoid calls when only the current region changes
                // onChange={
                //   (e) => {
                //console.log('e.target.checked: ', e.target.checked);
                //     setSingleApproved(e.target.checked);
                //   }
                // }
                checked={singleApproved}
                sx={{
                  color: green[300],
                  "&.Mui-checked": {
                    color: green[200],
                  },
                  // '&.Mui-disabled': {
                  //     color: grey[900],
                  // }
                }}
              />
            }
            label="Approve *"
            aria-label="Approve Segment"
          />
        </>
      ) : null}
      <Dialog
        open={openReturnModal}
        onClose={() => !isReturningToDescriber && setOpenReturnModal(false)}
        aria-labelledby="return-to-describer-title"
        aria-describedby="return-to-describer-description"
        PaperProps={{ sx: { backgroundColor: "#28262E", color: "white" } }}
      >
        <DialogTitle id="return-to-describer-title">Return to Describer?</DialogTitle>
        <DialogContent>
          <DialogContentText id="return-to-describer-description" sx={{ color: "rgba(255, 255, 255, .82)" }}>
            This action is irreversible. Are you sure you want to return this project to the describer?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenReturnModal(false)}
            disabled={isReturningToDescriber}
            sx={{ color: "white", backgroundColor: "#952937" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleReturnToDescriber}
            disabled={isReturningToDescriber}
            autoFocus
            sx={{ color: "white", backgroundColor: "#8EC36A" }}
          >
            {isReturningToDescriber ? "Returning..." : "Return to Describer"}
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={openToast}
        autoHideDuration={3000}
        onClose={() => setOpenToast(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={toastSeverity}>{message}</Alert>
      </Snackbar>
    </div>
  );
};
